interface planInfo {
  planUuid: string;
  interval: string | null;
}

async function createRetailerSubscriptionPlan(planInfo: planInfo, shopId: string | null) {
  const response = await fetch(
    process.env.REACT_APP_API_URL + `subscription/shopify/create-plan?shop=${shopId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify(planInfo)
    }
  );
  return response;
}

async function getRetailerCurrentSubscription(shopId: string | null) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}subscription/shopify/active-plan?shop=${shopId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Error fetching subscription Plan detail: ${response.statusText}`);
  }

  const subscriptionPlan: any = await response.json();
  return subscriptionPlan;
}

async function cancelRetailerSubscription(shopId: string | null) {
  const response = await fetch(
    process.env.REACT_APP_API_URL + `subscription/shopify/cancel-plan?shop=${shopId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );
  return response;
}

export {
  createRetailerSubscriptionPlan,
  getRetailerCurrentSubscription,
  cancelRetailerSubscription
};
